<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M18.236 4.77a1 1 0 011-1h7.693a1 1 0 011.089.996v7.663a1 1 0 11-2 0V6.944l-9.325 9.325c-.274.274-.813.18-1.203-.211-.39-.39-.485-.93-.211-1.204l9.085-9.085h-5.128a1 1 0 01-1-1z"/><path d="M7.862 8.385a1.683 1.683 0 00-1.683 1.683v14.335a1.683 1.683 0 001.683 1.683h14.335a1.683 1.683 0 001.684-1.683v-3.91a.923.923 0 011.846 0v3.91a3.53 3.53 0 01-3.53 3.53H7.862a3.53 3.53 0 01-3.529-3.53V10.068a3.53 3.53 0 013.53-3.53h3.909a.923.923 0 110 1.847h-3.91z"/></g></svg>
</template>

<script>
export default {
  name: 'webSystemExternalOutline'
}
</script>
